import { render, staticRenderFns } from "./GatheringEdit.vue?vue&type=template&id=46886bf2"
import script from "./GatheringEdit.vue?vue&type=script&lang=js"
export * from "./GatheringEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports